import type { ReactNode } from "react";
import styles from "./summary-strip.module.css";

export interface SummaryStripItem {
  label: string;
  value: ReactNode;
  description?: string;
}

export function SummaryStrip({
  items,
  ariaLabel,
}: {
  items: SummaryStripItem[];
  ariaLabel: string;
}) {
  return (
    <section className={styles.root} aria-label={ariaLabel}>
      {items.map((item) => (
        <div className={styles.item} key={item.label}>
          <span>{item.label}</span>
          <strong>{item.value}</strong>
          {item.description ? <small>{item.description}</small> : null}
        </div>
      ))}
    </section>
  );
}
